const pagesdata = [
    {
        title: "Home",
        icon: "Home",
        page: "HomeCom",
        path: "home"

    },
    // {
    //     title: "Dashboard",
    //     icon: "Dashboard",
    //     page: "Dashboard",
    //     path: "dashboard"
    // },
    {
        title: "Management",
        icon: "Management",
        page: "Management",
        path: "management",
        childrens: [
            {
                title: "Master Data",
                icon: "",
                page: "Masterdata",
                path: "masterdata",
                childrens: [
                    {
                        title: "Designations",
                        icon: "",
                        page: "Designations",
                        path: "designations"
                    },
                    {
                        title: "OfficeType",
                        icon: "",
                        page: "OfficeType",
                        path: "officetype",
                    },
                    {
                        title: "AllOffices",
                        icon: "",
                        page: "AllOffices",
                        path: "alloffices",
                    },
                    {
                        title: "AssetMaster",
                        icon: "",
                        page: "Assetmaster",
                        path: "assetmaster"

                    },
                    {
                        title: "ConsumablesMaster",
                        icon: "",
                        page: "ConsumablesMaster",
                        path: "consumablesmaster"

                    },
                    {
                        title: "StoreOffices",
                        icon: "",
                        page: "StoreOffices",
                        path: "storeoffices"
                    },
                    {
                        title: "DesignationSuffix",
                        icon: "",
                        page: "DesignationSuffix",
                        path: "designationsuffix"
                    },
                    {
                        title: "ComplaintMaster",
                        icon: "",
                        page: "ComplaintMaster",
                        path: "complaintmaster"
                    },
                    {
                        title: "EmailMaster",
                        icon: "",
                        page: "EmailMaster",
                        path: "emailmaster"
                    },
                    {
                        title: "BrandMaster",
                        icon: "",
                        page: "BrandMaster",
                        path: "brandmaster"
                    },
                    {
                        title: "ModelnoMaster",
                        icon: "",
                        page: "ModelnoMaster",
                        path: "modelnumber"
                    },
                    {
                        title: "VendorMaster",
                        icon: "",
                        page: "VendorMaster",
                        path: "vendornumber"
                    },
                    {
                        title: "AppIndividualAssets",
                        icon: "",
                        page: "AppIndividualAssets",
                        path: "appindividualassets"
                    }
                ]
            },
            {
                title: "Assets",
                icon: "",
                page: "Assetshome",
                path: "assets",
                childrens: [
                    {
                        title: "MyAssets",
                        icon: "",
                        page: "Myassets",
                        path: "myassets"

                    },
                   
                    {
                        title: "MyRequests",
                        icon: "",
                        page: "MyRequests",
                        path: "myrequests",
                        childrens: [
                            {
                                title: "IssueReq",
                                icon: "",
                                page: "IssueReq",
                                path: "issuereq"
                            },
                            {
                                title: "UserAssetReturnReq",
                                icon: "",
                                page: "UserAssetReturnReq",
                                path: "userassetreturnreq"
                            },
                            {
                                title: "BoAssetReturnReq",
                                icon: "",
                                page: "BoAssetReturnReq",
                                path: "boassetreturnreq"
                            },                   
                       
                        ]
                    },             

                    {
                        title: "AssetMan",
                        icon: "",
                        page: "AssetMan",
                        path: "AssetMan",
                        childrens: [
                            {
                                title: "AddAssets",
                                icon: "",
                                page: "Addassets",
                                path: "addassets"
        
                            },
                            {
                                title: "Assetapprove",
                                icon: "",
                                page: "Assetapprove",
                                path: "approveasset"
                            },
                            {
                                title: "AMinbox",
                                icon: "",
                                page: "AMinbox",
                                path: "AMinbox"
                            },
                            {
                                title: "AMSent",
                                icon: "",
                                page: "AMSent",
                                path: "AMSent"
                            },
                            {
                                title: "StoreAssetTransReq",
                                icon: "",
                                page: "StoreAssetTransReq",
                                path: "storeassetTransReq"
                            },
                            {
                                title: "StoreToStoreReq",
                                icon: "",
                                page: "StoreToStoreReq",
                                path: "StoreToStoreReq"
                            },
                            {
                                title: "Distribute",
                                icon: "",
                                page: "AssetDistribute",
                                path: "distribute"
                            },
                            {
                                title: "AssetSurrender",
                                icon: "",
                                page: "AssetSurrender",
                                path: "AssetSurrender"
                            },
                            {
                                title: "SurveyReport",
                                icon: "",
                                page: "SurveyReport",
                                path: "surveyreport",
                                childrens:[
                                    {
                                        title: "SurveyAssets",
                                        icon: "",
                                        page: "SurveyAssets",
                                        path: "surveyassets" 
                                    },
                                    {
                                        title: "ViewSurveyAssets",
                                        icon: "",
                                        page: "ViewSurveyAssets",
                                        path: "viewsurveyassets" 
                                    } 
                                ]
                            },

                        ]
                    },  
                    {
                        title: "AssetAnalytic",
                        icon: "",
                        page: "Assetanalytics",
                        path: "analytics"
                    },
                    {
                        title: "AssetReports",
                        icon: "",
                        page: "Assetreport",
                        path: "reports"
                    },
                    {
                        title: "AssetTransaction",
                        icon: "",
                        page: "Assettransaction",
                        path: "transaction"
                    },
                    {
                        title: "AssetForms",
                        icon: "",
                        page: "Assetforms",
                        path: "assetform"
                    }
                ]
            },
            {
                title: "Consumables",
                icon: "",
                page: "Consumables",
                path: "consumables",
                childrens: [
                    {
                        title: "MyConsumables",
                        icon: "",
                        page: "MyConsumables",
                        path: "myconsum"
                    },
                                        {
                        title: "OfficeConsum",
                        icon: "",
                        page: "OfficeConsum",
                        path: "officeconsum"
                    },
                    {
                        title: "ConsumablesReq",
                        icon: "",
                        page: "ConsumablesReq",
                        path: "consumablesreq",
                        childrens: [
                            {
                                title: "ConsumIssueReq",
                                icon: "",
                                page: "ConsumIssueReq",
                                path: "consumissuereq"
                            },
                            {
                                title: "BoToStoreConsumReq",
                                icon: "",
                                page: "BoToStoreConsumReq",
                                path: "botostoreconsumreq"
                            },
                        ]
                    },
                    {
                        title: "ConsumMan",
                        icon: "",
                        page: "ConsumMan",
                        path: "consumman",
                        childrens: [
                            {
                                title: "AddConsumables",
                                icon: "",
                                page: "AddConsumables",
                                path: "addconsumables"
                            },
                            {
                                title: "ConsumableApprove",
                                icon: "",
                                page: "ConsumableApprove",
                                path: "consumableapprove"
                            },
                            {
                                title: "CMinbox",
                                icon: "",
                                page: "CMinbox",
                                path: "cminbox"
                            },
                            {
                                title: "CMsentbox",
                                icon: "",
                                page: "CMsentbox",
                                path: "cmsentbox"
                            },
                            {
                                title: "DistributeConsum",
                                icon: "",
                                page: "DistributeConsum",
                                path: "distributeconsum"
                            },
                            {
                                title: "SurrenderConsum",
                                icon: "",
                                page: "SurrenderConsum",
                                path: "surrenderconsum"
                            }

                        ]
                    },
                    {
                        title: "ConsumTransac",
                        icon: "",
                        page: "ConsumTransac",
                        path: "consumtransac"
                    },

                ]
            },
            {
                title: "Users",
                icon: "",
                page: "Users",
                path: "users",
                childrens: [
                    {
                        title: "MyUsers",
                        icon: "",
                        page: "MyUsers",
                        path: "myusers"
                    },
                    {
                        title: "AddUsers",
                        icon: "",
                        page: "AddUsers",
                        path: "addusers"
                    },
                    {
                        title: "AddBulkUsers",
                        icon: "",
                        page: "AddBulkUsers",
                        path: "addbulkusers"
                    },
                    {
                        title: "UpdateBulkUsers",
                        icon: "",
                        page: "UpdateBulkUsers",
                        path: "updatebulkusers"
                    },
                    {
                        title: "EditUsers",
                        icon: "",
                        page: "EditUsers",
                        path: "editusers"
                    },
                    {
                        title: "ChangeOfficeReq",
                        icon: "",
                        page: "ChangeOfficeReq",
                        path: "chngofficeReq"
                    },
                    {
                        title: "UserChanges",
                        icon: "",
                        page: "UserChanges",
                        path: "userchanges"
                    },
                    {
                        title: "ApproveUsers",
                        icon: "",
                        page: "ApproveUsers",
                        path: "approveusers"
                    }
                ]
            },
            {
                title: "Complaints",
                icon: "",
                page: "Complaints",
                path: "complaints",
                childrens: [
  
                    {
                        title: "RegisterComplaint",
                        icon: "",
                        page: "RegisterComplaint",
                        path: "registercomplaint"
                    },
                                        {
                        title: "AllComplaints",
                        icon: "",
                        page: "AllComplaints",
                        path: "allcomplaints"
                    },
                ]

            },
            {
                title: "UnifiedInbox",
                icon: "",
                page: "UnifiedInbox",
                path: "unifiedinbox"
            },
            {
                title: "UnifiedSentbox",
                icon: "",
                page: "UnifiedSentbox",
                path: "unifiedsentbox"
            },
            {
                title: "Notifications",
                icon: "",
                page: "Notifications",
                path: "notifications"
            },
            {
                title: "Correction",
                icon: "",
                page: "Correction",
                path: "correction",
                childrens: [
                    {
                        title: "AssetTags",
                        icon: "",
                        page: "AssetTags",
                        path: "assettags"
                    },
                ]

            },
            {
                title: "FinalPdfForms",
                icon: "",
                page: "FinalPdfForms",
                path: "finalpdfforms",                

            },
            {
                title: "SystemLogs",
                icon: "",
                page: "SystemLogs",
                path: "systemlogs",
            }
        ]
    },
    {
        title: "MyProfile",
        icon: "MyProfile",
        page: "MyProfile",
        path: "myprofile",
        childrens: [
            {
                title: "ViewProfile",
                icon: "",
                page: "ViewProfile",
                path: "viewprofile"
            },
            {
                title: "EditPassword",
                icon: "",
                page: "EditPassword",
                path: "editpassword"
            },
            {
                title: "LoginSessions",
                icon: "",
                page: "LoginSessions",
                path: "loginsessions"
            },
            // {
            //     title: "MyActivity",
            //     icon: "",
            //     page: "UserActivityLogs",
            //     path: "myactivity"
            // }
        ]
    },
    {
        title: "Reports",
        icon: "Reports",
        page: "Reports",
        path: "reports"
    },
    {
        title: "SupportUsers",
        icon: "People",
        page: "SupportUsers",
        path: "supportusers",
        childrens: [
            {
                title: "AllSupportUsers",
                icon: "",
                page: "AllSupportUsers",
                path: "allsupportusers"
            },
            {
                title: "AddSupportUsers",
                icon: "",
                page: "AddSupportUsers",
                path: "addsupportusers"
            },
            {
                title: "EditSupportUsers",
                icon: "",
                page: "EditSupportUsers",
                path: "editsupportusers"
            },
            {
                title: "ComplaintsSup",
                icon: "",
                page: "ComplaintsSup",
                path: "complaintssup",
                childrens:[
                    {
                        title: "AllComplaints",
                        icon: "",
                        page: "AllComplaints",
                        path: "allcomplaints"
                    }, 
                ]
            }

            
        ]
    }
]

export default pagesdata;
